import { jsx as l, jsxs as u, Fragment as A } from "react/jsx-runtime";
import { autoPlacement as B, flip as G, shift as H, arrow as I, offset as J } from "@floating-ui/react";
import { forwardRef as K, useRef as L, cloneElement as Q, isValidElement as S } from "react";
import { DefaultArrow as T } from "./DefaultArrow.js";
import { DefaultContent as U } from "./DefaultContent.js";
import { PopoverWrapper as X } from "./PopoverWrapper.js";
import { usePopover as Y } from "./usePopover.js";
import { useMergeRefs as Z } from "../../utils/hooks/useMergeRefs.js";
const _ = (e) => S(e), $ = ({ withArrow: e = !1, offset: t }) => J(e ? 10 : (t ?? 0) * 4), ee = K(
  ({
    placement: e = "bottom",
    content: t,
    triggerEvent: g = "click",
    delay: y = !1,
    children: r,
    components: { Arrow: w = T, Content: P = U } = {},
    middlewares: R = [],
    offset: x,
    withArrow: a = !1,
    open: b,
    onOpenChange: v,
    inPortal: h = !1,
    positioning: n = "absolute",
    role: D = "dialog",
    classNames: m,
    style: E,
    disableOpenOnFocus: F,
    ...M
  }, j) => {
    const p = L(null), k = e === "auto" ? [B()] : [G()], C = e === "auto" ? "bottom" : e, {
      open: i,
      setOpen: N,
      x: O,
      y: V,
      refs: f,
      getFloatingProps: W,
      getReferenceProps: c,
      middlewareData: d,
      context: q
    } = Y({
      open: b,
      onOpenChange: v,
      strategy: n,
      role: D,
      delay: y,
      placement: C,
      triggerEvent: g,
      disableOpenOnFocus: F,
      // NOTE: The position of middleware matters.
      middlewares: [
        H(),
        $({ withArrow: a, offset: x }),
        ...k,
        I({ element: p, padding: 5 }),
        ...R
      ]
    });
    let s = null;
    const o = typeof r == "function" ? r(i) : r, z = Z(
      _(o) ? o.ref : null,
      f.setReference,
      j
    );
    return typeof o == "string" || typeof o == "number" ? s = /* @__PURE__ */ l("span", { ref: f.setReference, ...c(), children: o }) : s = Q(
      o,
      c({ ref: z, ...o.props, ...M })
    ), /* @__PURE__ */ u(A, { children: [
      s,
      i && t && /* @__PURE__ */ l(X, { inPortal: h, children: /* @__PURE__ */ u(
        P,
        {
          ref: f.setFloating,
          style: {
            position: n,
            top: V ?? 0,
            left: O ?? 0,
            ...E
          },
          className: m?.content,
          ...W(),
          children: [
            typeof t == "function" ? t(N) : t,
            a && /* @__PURE__ */ l(
              w,
              {
                ref: p,
                placement: q.placement,
                style: {
                  left: d.arrow?.x,
                  top: d.arrow?.y
                },
                className: m?.arrow
              }
            )
          ]
        }
      ) })
    ] });
  }
);
ee.displayName = "Popover";
export {
  ee as Popover
};
//# sourceMappingURL=Popover.js.map
